import './styles.css'
import browserUpdate from 'browser-update'
import BrowserConfig from './config'

export default () => browserUpdate(BrowserConfig)
